import { Container, spine } from "pixi.js";
import { GameModel } from "../../Models/GameModel";

export class SpineContainer{
    public container: Container;
    public spine: spine.Spine;

    private spineData;
    private currAnimation;
    private animName;
    private currentTrack;
    constructor(private model: GameModel, animations: string[], resource: string){
        this.container = new Container();
        this.prepareSpine(animations, resource);
    }

    prepareSpine(animations: string[], resource){


        this.spineData = this.model.spineResources[resource]?.spineData;
        if (!this.spineData) {
            setTimeout(() => {
                this.prepareSpine(animations, resource);
            }, 10);
        }
        if (this.spineData)
            this.spine = new PIXI.spine.Spine(this.spineData);
        else
            console.warn('cant get spine');

        if (this.spine) {
            this.container.addChild(this.spine);

            for (const index in animations) {
                this.spine.state.addAnimation(0, animations[index], false, 0);
            }
        }
    }

    public setAnimation(key: string, loop: boolean): void {
        if (this.spine && this.spine.state) {
            if (this.spine.state.hasAnimation(key)) {
                if (this.currAnimation !== key) {
                    this.spine.visible = true;
                    this.spine.autoUpdate = true;
                    this.spine.state.timeScale = 1;
                    this.currentTrack = this.spine.state.setAnimation(0, key, loop);
                    this.currAnimation = key;
                }
            } else {
                this.resetAnimation();
            }
        } else {
            this.resetAnimation();
        }
    }

    public resetAnimation(): void {
        this.currAnimation = '';

        if (this.spine && this.spine.state) {
            this.spine.visible = false;
            this.spine.autoUpdate = false;
            this.currentTrack = this.spine.state.setEmptyAnimation(0, 0);
        }
    }

}